import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    ForeignKey,
    PersonDetail
} from "../index";
import {BrandService} from "./brand.service";
import CustomTextField from "../typescript/custom-text-field/custom-text-field";
import CustomButton from "../typescript/custom-button/custom-button";
import CustomButtonGroup from "../typescript/custom-button-group/custom-button-group";
import {changePageTitle} from "../typescript/redux/actions";
import {WalletService} from "../typescript/wallet/wallet.service";
import {WalletDetail} from "../typescript/wallet/wallet-detail";
import NumberInput from "../typescript/number-input/number-input";
import {PersonService} from "../person/person.service";

export function BrandDetail({id, onClose, dialog}) {

    const [item, setItem] = useState(BrandService.createBrand());
    const dispatch = useDispatch();

    const findOne = useCallback(async () => {
        const result = await BrandService.findOne(id);
        setItem(result);
    }, [id]);

    useEffect(() => {
        if (!dialog) {
            dispatch(changePageTitle(id ? "Bandeira " + id : "Nova bandeira"));
        }
        if (id) {
            findOne().then();
        }
    }, [dispatch, findOne, id, dialog]);

    const save = (event) => {
        event.preventDefault();
        event.stopPropagation();
        BrandService.save(item).then((result) => {
            onClose(result.data);
        }).catch(() => {

        })
    }

    const cancel = () => {
        onClose();
    }

    const setDescricao = (event) => {
        setItem({
            ...item,
            descricao: event.target.value
        })
    }

    const setPrazoParaEntrar = (event) => {
        setItem({
            ...item,
            prazoParaEntrar: event.target.value
        })
    }

    const onChangePessoa = async (id) => {
        setItem({
            ...item,
            pessoa: {
                id: id
            }
        })
        if (id) {
            const pessoa = await PersonService.findOne(id);
            if (pessoa) {
                setItem({
                    ...item,
                    pessoa: pessoa
                })
            }
        }
    }

    const onAddPessoa = (pessoa) => {
        if (pessoa) {
            setItem({
                ...item,
                pessoa: pessoa
            })
        }
    }

    const findPessoas = (page, size, sort, filter) => {
        return PersonService.findAll(page, size, sort, filter);
    }

    const onChangeCarteira = async (id) => {
        setItem({
            ...item,
            carteira: {
                id: id
            }
        })
        if (id) {
            const carteira = await WalletService.findOne(id);
            if (carteira) {
                setItem({
                    ...item,
                    carteira: carteira
                })
            }
        }
    }

    const onAddCarteira = (carteira) => {
        if (carteira) {
            setItem({
                ...item,
                carteira: carteira
            })
        }
    }

    const findCarteiras = (page, size, sort, filter) => {
        return WalletService.findAll(page, size, sort, filter);
    }

    return (
        <form onSubmit={save}>
            <CustomTextField fullWidth autoFocus required label="Descrição" value={item.descricao}
                             onChange={setDescricao}/>
            <NumberInput fullWidth label="Prazo para entrar" value={item.prazoParaEntrar || ''}
                         onChange={setPrazoParaEntrar}/>
            <ForeignKey fullWidth required label="Fornecedor" value={item.pessoa} fieldKey={'id'}
                        fieldDescription={'nome'} labelDescription='Nome' onChange={onChangePessoa}
                        onSelect={onAddPessoa} onAdd={onAddPessoa} findAll={findPessoas}
                        dataColumnNames={['ID', 'Nome']} dataColumns={['id', 'nome']}
                        dataTypes={['number', 'text']} addComponent={<PersonDetail/>}/>
            <ForeignKey fullWidth required label="Conta" value={item.carteira} fieldKey={'id'}
                        fieldDescription={'descricao'} labelDescription='Descrição' onChange={onChangeCarteira}
                        onSelect={onAddCarteira} onAdd={onAddCarteira} findAll={findCarteiras}
                        dataColumnNames={['ID', 'Descrição']} dataColumns={['id', 'descricao']}
                        dataTypes={['number', 'text']} addComponent={<WalletDetail/>}/>
            <CustomButtonGroup>
                <CustomButton color="primary" type="submit">Salvar</CustomButton>
                <CustomButton type="button" color="neutral" onClick={cancel}>Cancelar</CustomButton>
            </CustomButtonGroup>
        </form>
    )
}